var React = require('react');

function ToolPremiere (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-foreground"},[React.createElement("path",{"d":"M21,27L21,15.1l0-0.1l0.1-0.1c0,0,0.9-0.7,2.2-0.9c0.6-0.2,1.4-0.3,2.4-0.3c0.7,0,1.3,0.1,1.3,0.1l0.2,0v3.1h-2\n\t\tc-0.6,0-0.9,0.1-1,0.1v10H21z","key":0}),React.createElement("path",{"d":"M14.4,9H8.7v17.6h3.1v-5.8l2.1,0c0.1,0,5.3-0.8,5.3-6C19.2,9.5,14.4,9,14.4,9z M11.7,12.2h2.5c0.2,0,1.9,0.3,1.9,2.6\n\t\t\tc0,2.4-2.5,2.8-2.6,2.8h-1.8V12.2z","key":1})]));
}

ToolPremiere.defaultProps = {"version":"1.1","width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = ToolPremiere;

ToolPremiere.default = ToolPremiere;
